import { createBaseUmi } from '@metaplex-foundation/umi';
import { defaultPlugins } from './plugin.mjs';
export { defaultPlugins } from './plugin.mjs';

function createUmi(endpointOrConnection, rpcOptions) {
  return createBaseUmi().use(typeof endpointOrConnection === 'string' ? defaultPlugins(endpointOrConnection, rpcOptions) : defaultPlugins(endpointOrConnection, rpcOptions));
}

export { createUmi };
//# sourceMappingURL=index.mjs.map
